export default __webpack_public_path__ + "static/media/high-res-logo-p-500.82d2205e.png";